import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      loadUser();
    } else {
      setLoading(false);
    }
  }, []);

  const loadUser = async () => {
    try {
      // Delay mínimo para mostrar o splash por mais tempo
      const [response] = await Promise.all([
        api.get('/api/auth/me'),
        new Promise(resolve => setTimeout(resolve, 1500)) // Mínimo de 1.5s de splash
      ]);
      setUser(response.data.data.user);
    } catch (error) {
      localStorage.removeItem('token');
      delete api.defaults.headers.common['Authorization'];
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, senha) => {
    try {
      console.log('🔐 AuthContext: Fazendo requisição de login...');
      const response = await api.post('/api/auth/login', { email, senha });
      console.log('🔐 AuthContext: Resposta recebida:', response.data);
      
      if (response.data && response.data.success && response.data.data) {
        const { token, user } = response.data.data;
        
        if (!token || !user) {
          console.error('❌ Token ou user não encontrados na resposta');
          return { success: false, error: 'Resposta inválida do servidor' };
        }
        
        localStorage.setItem('token', token);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        setUser(user);
        
        console.log('✅ AuthContext: Login bem-sucedido, user:', user);
        return { success: true, user };
      } else {
        console.error('❌ Resposta não tem success ou data');
        return { success: false, error: response.data?.message || 'Erro ao fazer login' };
      }
    } catch (error) {
      console.error('❌ AuthContext: Erro no login:', error);
      console.error('   Response:', error.response?.data);
      const message = error.response?.data?.message || error.message || 'Erro ao fazer login';
      return { success: false, error: message };
    }
  };

  const register = async (userData) => {
    try {
      const response = await api.post('/api/auth/register', userData);
      const { token, user } = response.data.data;
      
      localStorage.setItem('token', token);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(user);
      
      toast.success('Cadastro realizado com sucesso!');
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.message || 'Erro ao fazer cadastro';
      toast.error(message);
      return { success: false, error: message };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
    window.location.href = '/login';
    toast.success('Logout realizado com sucesso!');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider');
  }
  return context;
};

